import cn from 'classnames';
import React, {FC} from 'react';

import {IWidgetsLayout} from 'entities/metadata';

import {createLinkButtonPropsWithPreset} from '../link-button';
import {WidgetLayout} from '../widget-layout';

interface IDictionaryLayoutItemProps {
    dictionary: IWidgetsLayout;
}

export const DictionaryLayoutItem: FC<IDictionaryLayoutItemProps> = ({dictionary}: IDictionaryLayoutItemProps) => {
    const className = dictionary.icon?.toString().toLowerCase();

    return (
        <WidgetLayout
            title={dictionary.title}
            iconName={dictionary.icon}
            className={cn(className)}
            buttons={dictionary.url ? {
                bottom: [
                    createLinkButtonPropsWithPreset({link: dictionary.url, preset: 'PASS_TO_SECTION'}),
                ],
            } : undefined}
        />

    );
};
